export async function hashString(arg: string) {
	const utf8 = new TextEncoder().encode(arg);
	const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const hashHex = hashArray
		.map((bytes) => bytes.toString(16).padStart(2, "0"))
		.join("");
	return hashHex;
}

export function capitalizeFirstLetter(arg: string) {
	return arg.charAt(0).toUpperCase() + arg.slice(1);
}

export function capitalizeName(name: string | undefined): string {
	if (!name) return "";
	return name
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
}

// Helper function to format date for HTML date input (YYYY-MM-DD)
export const formatDateForInput = (dateString?: string) => {
	if (!dateString) return "";
	try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return "";
		return date.toISOString().split("T")[0];
	} catch {
		return "";
	}
};

// Format date for display on posts and jobs
// Shows relative time for today and current week, exact date otherwise
export const formatCreatedAt = (dateString: string): string => {
	if (!dateString) return "";

	try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return "";

		const now = new Date();
		const diffMs = now.getTime() - date.getTime();
		const diffMinutes = Math.floor(diffMs / (1000 * 60));
		const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
		const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

		// If posted today (within 24 hours and same day)
		const isSameDay =
			date.getDate() === now.getDate() &&
			date.getMonth() === now.getMonth() &&
			date.getFullYear() === now.getFullYear();

		if (isSameDay) {
			if (diffMinutes < 1) return "just now";
			if (diffMinutes < 60) return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
			return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
		}

		// If within the current week (last 7 days)
		if (diffDays < 7) {
			if (diffDays === 1) return "Yesterday";
			return `${diffDays} days ago`;
		}

		// For older dates, show exact date
		const currentYear = now.getFullYear();
		const dateYear = date.getFullYear();

		const months = [
			"Jan", "Feb", "Mar", "Apr", "May", "Jun",
			"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
		];

		const month = months[date.getMonth()];
		const day = date.getDate();

		// If same year, don't show year
		if (dateYear === currentYear) {
			return `${month} ${day}`;
		}

		// Different year, include year
		return `${month} ${day}, ${dateYear}`;
	} catch {
		return "";
	}
};
